// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"FZ-z","sponsoredTooltipWrapper":"GZ-z","sponsoredTooltip":"HZ-z","newCard":"IZ-z"};